import styled from 'styled-components';

import Plus from 'assets/icons/nav/icon-plus-16.svg';

import { commonMaxWidth, flexAllCenter, flexRowSpaceBetween, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';
export const GLOBAL_STATS_CHART_HEIGHT = 320;

export const Container = styled.main`
    height: 100%;
    position: relative;
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    scroll-behavior: smooth;
    overflow: auto;
    background-color: ${COLORS.gray50};
`;

export const Content = styled.div`
    ${commonMaxWidth};
    width: 100%;
    padding: 1.6rem 4rem 0;
    flex: 1 0 auto;

    ${respondDown(Breakpoints.sm)`
        padding: 2rem 1.6rem 0;
    `}
`;

export const Section = styled.div`
    flex: 1 0 auto;
    ${flexAllCenter};
    background-color: ${COLORS.white};
    width: 100%;
    margin-bottom: 1.6rem;

    ${respondDown(Breakpoints.md)`
        background-color: ${COLORS.gray50};
    `}
`;

export const PlusIcon = styled(Plus)`
    width: 1.6rem;
    height: 1.6rem;
    margin-left: 1rem;
`;

export const ListBlock = styled.div`
    padding: 5.2rem 3.2rem;
    width: 100%;

    ${respondDown(Breakpoints.sm)`
        padding: 3rem 0;
    `}
`;

export const ListHeader = styled.div`
    ${flexRowSpaceBetween};

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        gap: 2.4rem;
    `}
`;

export const ListTotal = styled.span`
    font-size: 1.6rem;
    line-height: 2.8rem;

    span:last-child {
        font-weight: 700;
    }
`;

export const Charts = styled.div`
    display: flex;
    justify-content: space-evenly;
    gap: 1.6rem;
    width: 100%;
    background-color: ${COLORS.gray50};

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
    `}
`;

export const Chart = styled.div`
    ${flexAllCenter};
    min-height: calc(${GLOBAL_STATS_CHART_HEIGHT}px + 3.2rem);
    background-color: ${COLORS.white};
    padding: 1.6rem;
    border-radius: 0.6rem;
    flex: 1;
    width: 100%;

    ${respondDown(Breakpoints.xl)`
        flex-direction: column;
        background-color: ${COLORS.white};
    `}
`;
